import {
    DocumentationSubflowNodeResult,
    DocumentationSubflowStepNodeResult,
    DocumentationWorkflowNodeChanges,
    DocumentationWorkflowNodeResult
} from "./models";

export type WorkflowNodeEdits = Record<string, string>;

export type StandaloneWorkflowNodeItem = {
    kind: "node";
    node: Exclude<DocumentationWorkflowNodeResult, DocumentationSubflowNodeResult | DocumentationSubflowStepNodeResult>;
};

export type WorkflowSubflowItem = {
    kind: "subflow";
    node: DocumentationSubflowNodeResult;
    steps: DocumentationSubflowStepNodeResult[];
};

export type OrphanedSubflowStepItem = {
    kind: "orphaned_subflow_step";
    node: DocumentationSubflowStepNodeResult;
};

export type WorkflowNodeRenderItem = StandaloneWorkflowNodeItem | WorkflowSubflowItem | OrphanedSubflowStepItem;

export function groupWorkflowNodeResults(nodes: DocumentationWorkflowNodeResult[]): WorkflowNodeRenderItem[] {
    const items: WorkflowNodeRenderItem[] = [];
    let index = 0;

    while (index < nodes.length) {
        const node = nodes[index];
        switch (node.node_type) {
            case "subflow": {
                const item: WorkflowSubflowItem = { kind: "subflow", node, steps: [] };
                let childIndex = index + 1;
                while (childIndex < nodes.length) {
                    const child = nodes[childIndex];
                    if (child.node_type !== "subflow_step" || child.parent_subflow_id !== node.node_id) break;
                    item.steps.push(child);
                    childIndex += 1;
                }
                items.push(item);
                index = childIndex;
                break;
            }
            case "subflow_step":
                items.push({ kind: "orphaned_subflow_step", node });
                index += 1;
                break;
            case "step":
            case "outcome":
                items.push({ kind: "node", node });
                index += 1;
                break;
        }
    }

    return items;
}

export function getWorkflowNodeContent(node: DocumentationWorkflowNodeResult, edits: WorkflowNodeEdits): string {
    return Object.prototype.hasOwnProperty.call(edits, node.node_id) ? edits[node.node_id] : node.content;
}

export function buildWorkflowNodeChanges(nodes: DocumentationWorkflowNodeResult[], edits: WorkflowNodeEdits): DocumentationWorkflowNodeChanges {
    const changes: DocumentationWorkflowNodeChanges = {};
    for (const node of nodes) {
        if (node.display_mode === "source_links") continue;
        if (Object.prototype.hasOwnProperty.call(edits, node.node_id)) changes[node.node_id] = edits[node.node_id];
    }
    return changes;
}
